import HttpService from "./HttpService";
const API_ENDPOINT = "/health-insurance";

const HealthInsuranceService = {
  async getSetting() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/setting`);
      return response?.data;
    } catch (error) {
      console.error("unable to fetch health insurance setting:", error);
      throw error?.response?.data || error;
    }
  },
  async updateSetting(payload) {
    try {
      const response = await HttpService.post(
        `${API_ENDPOINT}/update-setting`,
        payload,
      );
      return response?.data;
    } catch (error) {
      console.error("unable to update health insurance setting:", error);
      throw error?.response?.data || error;
    }
  },
};

export default HealthInsuranceService;
